import { render, staticRenderFns } from "./ProfileUniqueTcont.vue?vue&type=template&id=c6e9fec4&"
import script from "./ProfileUniqueTcont.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueTcont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports